module.exports = __webpack_public_path__ + "static/media/key-circle.a335fa45.svg";